/** @module csi/slicer/ChartController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/def",
	"csi/prefs/_base"
], function(declare,_,ActionView,Controller,def,csiPrefs) {

	var KEYS = {
		ChartTemplate: "chartType",
		ChartHeight: "chartHeight",
		ChartWidth: "chartWidth"
	};

	return declare(Controller, {
		/**
		 * Return reference to chart wizard defined on _CS_PreferenceView.
		 * @param {ViewRef} vr - ignored
		 * @return {ActionView}
		 */
		getActionView: function(vr) {
			var	defType = def.typeDefinition(csiPrefs.TYPE_VIEW);
			var	defView = defType.getViewDef("SlicerChartForm");
			return new ActionView(this, defView, this.getCache().getNode(this.widget.get("customViewId")));
		},

		/**
		 * Initialize form data with values from existing chart.
		 * @return {FormData}
		 */
		getFormData: function() {
			var fd = this.m_formData;
			if (!fd) {
				var attrs = _.invert(KEYS);
				var chartValues = this.widget.get("graphSettings");

				fd = this.inherited(arguments);

				_.each(chartValues, function(value, key) {
					// we no longer support 3D charts, so replace with 2D variant
					if (key == "chartType") {
						value = value.replace(/3D/, "2D");
					}

					fd.setFieldInitialValue(attrs[key], value);
				});
			}

			return fd;
		},

		/**
		 * Initialize form data with values from existing chart.
		 */
		process: function() {
			this.actionValue = {graphSettings: this._getChartValues()};
			this.inherited(arguments);
		},

		/**
		 * Return object with values of all fields.
		 * @return {Object}
		 */
		_getChartValues: function() {
			var obj = {};

			_.each(this.m_formData.getFields(), function(field) {
				var name = KEYS[field.getControlName()];
				var value = field.getValue();
				obj[name] = value;
			});

			return obj;
		}
	});
});
